import { EnvelopeType } from '../../../global-types/envelope';
import { useFeatureFlags } from '../../../hooks';
import { useIsOneToMany } from '../../../hooks/use-is-one-to-many';

export type UseShouldHideFormResponse = {
  shouldHideForm: boolean;
};

export const useShouldHideForm = (
  // envelope comes from useAddressSubmit which is used for the /address view
  envelope: EnvelopeType,
  // selectedEnvelope comes from useEnvelopeSelection which is used for the /envelope view
  selectedEnvelope: EnvelopeType,
): UseShouldHideFormResponse => {
  const { IS_ENVELOPE_PRINTING_OPTIONS_ENABLED } = useFeatureFlags();
  const isOneToMany = useIsOneToMany();

  // 1:1 card should always show the form on reload, since they can't select an envelope
  if (!isOneToMany) {
    return {
      shouldHideForm: false,
    };
  }

  if (IS_ENVELOPE_PRINTING_OPTIONS_ENABLED) {
    return {
      shouldHideForm: selectedEnvelope === EnvelopeType.Blank,
    };
  }

  if (isOneToMany) {
    return {
      shouldHideForm: envelope === EnvelopeType.Blank,
    };
  }

  return {
    shouldHideForm: false,
  };
};
